import { Config } from "@spartacus/core";
import { SlbConfigService } from "../services/slb-config.service";
import { slbAuthConfig } from "./slb-auth.config";
import { slbOccConfig } from "./slb-occ.config";
import { slbSmartEditConfig } from "./slb-smart-edit.config";
import { slbContextConfig } from "./slb-context.config";
import { inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

const BASE_STORE = 'slb';

export const slbConfig = (SlbConfig: SlbConfigService): Config => {
    const platformId = inject(PLATFORM_ID);
    const isBrowser = isPlatformBrowser(platformId);

    const pathName =
        isBrowser && typeof window !== 'undefined' ? window.location.pathname.split('/').at(1) : undefined;

    const configurations = SlbConfig.getSlbConfig();
    const authConfig = slbAuthConfig(configurations);
    const occConfig = slbOccConfig(configurations);
    const contextConfig = slbContextConfig(configurations, pathName ?? BASE_STORE);
    return {
        ...authConfig,
        ...occConfig,
        ...contextConfig
    }
}

export const smartEditConfig =(SlbConfig: SlbConfigService): Config => {
    const configurations = SlbConfig.getSlbConfig();
    const smartEditConfig = slbSmartEditConfig(configurations);
    return {
        ...smartEditConfig
    }
}